import { XAxisGranularity } from './timeSeriesProcessing';

export const TIME_SERIES_IMAGE_GRANULARITIES: XAxisGranularity[] = ['month', 'quarter', 'year', 'fiscalYear'];

export const TIME_SERIES_IMAGE_METRICS = [
  '結果の内訳',
  '未実施理由の内訳',
  '未実施理由の職種別内訳',
] as const;

export type TimeSeriesImageMetric = typeof TIME_SERIES_IMAGE_METRICS[number];

export type TimeSeriesImageDisplayMode = 'ratio' | 'count';

export const getTimeSeriesCaptureStateKey = (
  metric: TimeSeriesImageMetric,
  granularity: XAxisGranularity,
  displayMode: TimeSeriesImageDisplayMode,
): string => `${metric}::${granularity}::${displayMode}`;

export const getTimeSeriesImageMetrics = (hasReasonData: boolean): TimeSeriesImageMetric[] =>
  hasReasonData
    ? [...TIME_SERIES_IMAGE_METRICS]
    : TIME_SERIES_IMAGE_METRICS.filter((metric) => metric !== '未実施理由の内訳');
